import {detect} from 'detect-browser';

const browser = detect();

export default {
    init() {
        const version = Number(browser.version.split('.')[0]);
        if(browser.name === 'ie') {
            document.body.classList.add('ie');
            if(version < 11) {
                document.body.classList.add('ie-lt-11');
            }
            if(version < 10) {
                document.body.classList.add('ie-lte-9');
            } else if(version === 10) {
                document.body.classList.add('ie-10');
            } else {
                document.body.classList.add('ie-gte-11');
            }
        }
    },
    isIE() {
        return browser.name === 'ie';
    },
};



// WEBPACK FOOTER //
// ./src/utils/Browser.js